import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import { ToastContainer, toast } from "react-toastify";
import LoanPaymentChangePane from "./LoanPaymentChangePane";
import { getTrans as t } from "../../../../Localization/translations";
import { confirmAlert } from "react-confirm-alert"; // Import
import LoanDueDayChangePane from "./LoanDueDayChangePane";

export default function LoanModification({ contractId, contractdetails,modificationType }) {
  const [openPane, setOpenPane] = useState(false);
  const [newInterestRate, setNewInterestRate] = useState("");
  const [draftId, setDraftId] = useState(null);
  // const [modificationType, setModificationType] =
  //   useState("InterestRateChange");
  // const [modificationType, setModificationType] =
  // useState(props.modificationTypes || "InterestRateChange");
  const currentModificationType = modificationType;
  const [draftContract, setDraftContract] = useState(null);
  const [interestRateType, setInterestRateType] = useState("Fixed");
  const [baseRate, setBaseRate] = useState("");
  const [margin, setMargin] = useState("");
  const [billedRows, setBilledRows] = useState([]);
  const [interestOnlyType, setInterestOnlyType] = useState(null);
  const [showInterestOnly, setShowInterestOnly] = useState(false);
  const [editableInterestPeriods, setEditableInterestPeriods] = useState({});
  console.log("CONTRACT DETAILS IN MOD", contractId);

  // const handlepayment = (state) => {
  //     let url = API + `contracts/contracts/${state}/loan-payment-schedule/`;
  //     axios
  //       .get(url, { headers: authHeader() })
  //       .then((response) => {
  //         // setItems(response.data.data);
  //       });
  //   };

  const [recalcVersion, setRecalcVersion] = useState(0);

  useEffect(() => {
    if (currentModificationType === "InterestRateChange") {
      setOpenPane(true);
    }
  }, [currentModificationType]);

  const recalcLoanSchedule = async (draftId) => {
    await axios.post(
      `${API}contracts/contracts/${draftId}/loan-payment-schedule/`,
      {},
      { headers: authHeader() },
    );
  };
  const submitInterestChange = async () => {
    if (!newInterestRate) {
      toast.error("Enter new interest rate");
      return;
    }

    try {
      // 1️⃣ Create / update draft
      const res = await axios.post(
        `${API}contracts/contracts/${contractId}/loan-modify/`,
        {
          amendment_type: "INTEREST_RATE_CHANGE",
          new_interest_rate:
            interestRateType === "Fixed"
              ? contractdetails?.iir // ✅ force current value
              : parseFloat(newInterestRate),

          //  parseFloat(newInterestRate),
          interest_rate_type: interestRateType,
          base_rate: interestRateType === "Floating" ? parseFloat(baseRate) : 0,
          margin: interestRateType === "Floating" ? parseFloat(margin) : 0,

          // 🔥 ADD THIS
          interest_only: showInterestOnly
            ? {
                type: interestOnlyType,
                rows: billedRows,
              }
            : null,
        },
        { headers: authHeader() },
      );

      const draftId = res.data.draft_contract_id;
      setDraftId(draftId);

      // 2️⃣ WAIT for recalculation to COMPLETE
      await axios.post(
        `${API}contracts/contracts/${draftId}/loan-payment-schedule/`,
        {},
        { headers: authHeader() },
      );

      // 3️⃣ 🔥 FORCE REFRESH
      setRecalcVersion((v) => v + 1);

      setOpenPane(true);
      toast.success("Interest updated & recalculated");
    } catch (e) {
      toast.error("Failed to update interest rate");
    }
  };

  const [mergedPaymentDetails, setMergedPaymentDetails] = useState([]);
  const [amortData, setAmortData] = useState([]);

  const activateLoanModification = async () => {
    if (!draftId) {
      toast.error("No draft available to activate");
      return;
    }

    try {
      await axios.post(
        `${API}contracts/contracts/${draftId}/loan-modification-activate/`,
        {
          items: mergedPaymentDetails, // coming from pane
          amort: amortData, // pass amort data
        },
        { headers: authHeader() },
      );

      toast.success("Loan modification activated");
      // setOpenPane(true);

      // 🔄 reload page / parent contract
      window.location.reload();
    } catch (e) {
      toast.error("Failed to activate modification");
    }
  };

  console.log("MERGED PAYMENT DETAILS", mergedPaymentDetails);

  // const submitInterestChange = async () => {
  //   if (!newInterestRate) {
  //     toast.error("Enter new interest rate");
  //     return;
  //   }

  //   try {
  //     const res = await axios.post(
  //       `${API}contracts/contracts/${contractId}/loan-modify/`,
  //       {
  //         // amendment_type: "INTEREST_RATE_CHANGE",
  //         new_interest_rate: parseFloat(newInterestRate),
  //       },
  //       { headers: authHeader() }
  //     );

  //     setDraftId(res.data.draft_contract_id);
  //     handlepayment(res.data.draft_contract_id);
  //     toast.success("Interest rate change draft created");
  //     setOpenPane(true);
  //   } catch (e) {
  //     toast.error("Failed to create interest rate change");
  //   }
  // };

  // console.log("CONTRACT DETAILS IN MOD", draftId);
  // console.log("CONTRACT DETAILS IN MOD", draftContract);

  useEffect(() => {
    // setOpenPane(true);
    axios
      .get(`${API}contracts/contracts/${contractId}/versions/`, {
        headers: authHeader(),
      })
      .then((res) => {
        const versions = res.data.versions || [];

        // ✅ find latest ContractMod
        const draft = versions
          .filter((v) => v.status === "ContractMod")
          .sort((a, b) => b.version - a.version)[0];

        console.log("LOAN MOD DRAFT", draft);

        // setDraftId(draft ? draft.id : null);
        if (!draftId && draft) {
          setDraftId(draft.id);
        }

        if (draft) {
          const contract =
            draft.contracts?.find((c) => c.status === "ContractMod") ||
            draft.contracts?.find((c) => c.id === draft.id) ||
            null;
          // const contract = draft.contracts?.[0] || null;
          console.log("CONTRACT IN DRAFT", contract);

          setDraftContract(contract);

          // ✅ THESE come from VERSION, not contract
          // setTotalRent(draft.payment_rent_sum || 0);
          // setOneTimeFeeSum(draft.one_time_fee_sum || 0);

          setNewInterestRate(contract?.iir || 0);
          setInterestRateType(contract?.interest_rate_type || "Fixed");
          if (contract?.interest_rate_type === "Floating") {
            setBaseRate(contract?.base_rate || 0);
            setMargin(contract?.margin || 0);
          } else {
            setBaseRate(0);
            setMargin(0);
          }
          console.log("DRAFT CONTRACT IN MOD", contract?.iir);
        } else {
          setDraftContract(null);
          // setTotalRent(0);
          // setOneTimeFeeSum(0);
          // if(interestRateType === "Floating"){

          //   setNewInterestRate(0);
          // }
           setInterestRateType(contractdetails?.interest_rate_type || "Fixed");

            if (contractdetails?.interest_rate_type === "Floating") {
              setBaseRate(contractdetails?.base_rate || 0);
              setMargin(contractdetails?.margin || 0);
            } else {
              setBaseRate(0);
              setMargin(0);
            }

          setNewInterestRate(contractdetails?.iir || 0);
          // setInterestRateType("Fixed");
          // setBaseRate(0);
          // setMargin(0);
        }
      });
  }, [openPane, contractId, recalcVersion]);


  //   const abandonContract = async () => {
  //   if (!draftId) {
  //     toast.error("No draft to delete");
  //     return;
  //   }

  //   if (!window.confirm("Are you sure you want to abandon this contract modification?")) {
  //     return;
  //   }

  //   try {
  //     await axios.delete(
  //       `${API}contracts/contractsmod/${draftId}/delete-mod/`,
  //       { headers: authHeader() }
  //     );

  //     toast.success("Contract modification abandoned");

  //     // Reset state
  //     setDraftId(null);
  //     setDraftContract(null);
  //     setOpenPane(false);

  //     // Reload to reflect changes
  //     window.location.reload();

  //   } catch (e) {
  //     toast.error("Failed to delete contract modification");
  //   }
  // };

  const abandonContract = async () => {
    if (!draftId) {
      toast.error("No draft to delete");
      return;
    }

    confirmAlert({
      title: "",
      message: "Are you sure you want to delete this amendment?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              await axios.delete(
                `${API}contracts/contractsmod/${draftId}/delete-mod/`,
                { headers: authHeader() },
              );

              toast.success("Amendment abandoned");

              // Reset state
              setDraftId(null);
              setDraftContract(null);
              setOpenPane(false);

              // Reload
              window.location.reload();
            } catch (e) {
              toast.error("Failed to delete Amendment");
            }
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  useEffect(() => {
    if (interestRateType === "Floating") {
      const total = (parseFloat(baseRate) || 0) + (parseFloat(margin) || 0);
      setNewInterestRate(total);
    }
  }, [baseRate, margin, interestRateType]);

  useEffect(() => {
    if (!contractdetails || !showInterestOnly) return;

    const months = contractdetails.interest_only_payments || 0;
    const start = new Date(contractdetails.start_date);

    const rows = [];

    for (let i = 0; i < months; i++) {
      const from = new Date(start);
      from.setMonth(start.getMonth() + i);

      const to = new Date(start);
      to.setMonth(start.getMonth() + i + 1);
      to.setDate(0);

      const days = Math.round((to - from) / (1000 * 60 * 60 * 24)) + 1;

      rows.push({
        period: i + 1,
        fromDate: from.toISOString().split("T")[0],
        toDate: to.toISOString().split("T")[0],
        periodDays: days,
        interestRate: newInterestRate,
        dayConvention: "Actual/360",
        billAmount: calculateInterestAmount(
                                      contractdetails.loanamount,
                                      newInterestRate,
                                      days,
                                      "Actual/360",
                                    ),
      });
    }

    setBilledRows(rows);
  }, [contractdetails, showInterestOnly]);

  // useEffect(() => {
  //   if (!contractId) return;

  //   axios
  //     .get(`${API}contracts/interest-only/`, {
  //       params: { contract_id: contractId },
  //       headers: authHeader(),
  //     })
  //     .then((res) => {
  //       if (!res.data.success) return;

  //       const rows = res.data.rows || [];
  //       const type = res.data.interest_only_type;

  //       // ✅ ONLY SHOW IF BILL
  //       if (type === "BILL" && rows.length > 0) {
  //         setInterestOnlyType(type);
  //         setShowInterestOnly(true);

  //         setBilledRows(
  //           rows.map((r) => ({
  //             period: r.period_no,
  //             interestRate: r.interest_rate,
  //             dayConvention: r.day_convention,
  //             billAmount: r.bill_amount,
  //           }))
  //         );
  //       } else {
  //         // ❌ HIDE UI
  //         setShowInterestOnly(false);
  //         setBilledRows([]);
  //       }
  //     })
  //     .catch(() => {
  //       setShowInterestOnly(false);
  //     });
  // }, [contractId]);

  const parseDate = (dateStr) => {
    if (!dateStr) return null;

    // if already ISO format → safe
    if (dateStr.includes("-")) {
      return new Date(dateStr);
    }

    // handle DD/MM/YYYY
    const parts = dateStr.split("/");
    if (parts.length === 3) {
      const [day, month, year] = parts;
      return new Date(`${year}-${month}-${day}`);
    }

    return null;
  };

  useEffect(() => {
    const idToUse = draftId || contractId;
    if (!idToUse) return;

    axios
      .get(`${API}contracts/interest-only/`, {
        params: {
          contract_id: idToUse, // 🔥 dynamic
        },
        headers: authHeader(),
      })
      .then((res) => {
        if (!res.data.success) return;

        const rows = res.data.rows || [];
        const type = res.data.interest_only_type;

        if (type === "BILL" && rows.length > 0) {
          setInterestOnlyType(type);
          setShowInterestOnly(true);
          const frequencyMonthsMap = {
            Monthly: 1,
            Quarterly: 3,
            "Semi-annual": 6,
            Annual: 12,
          };

          const cycleMonths =
            frequencyMonthsMap[contractdetails?.paymentfrequency] || 1;

          // 🔥 IMPORTANT: use contract start_date
          const baseDate = new Date(contractdetails?.start_date);

          setBilledRows(
            rows.map((r, index) => {
              const start = new Date(baseDate);
              start.setMonth(start.getMonth() + index * cycleMonths);

              // 👉 calculate period end
              const end = new Date(start);
              end.setMonth(end.getMonth() + cycleMonths);
              end.setDate(end.getDate() - 1);

              // 👉 calculate days
              const days =
                Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1;

              console.log("PERIOD", index + 1, start, end, days);
              return {
                period: r.period_no,
                interestRate: r.interest_rate,
                dayConvention: r.day_convention,
                billAmount: r.bill_amount,

                // 🔥 ADD THESE (IMPORTANT)
                periodDays: days,
                fromDate: r.start_date,
                toDate: r.end_date,
              };
            }),
          );
          // setBilledRows(
          //   rows.map((r) => ({
          //     period: r.period_no,
          //     interestRate: r.interest_rate,
          //     dayConvention: r.day_convention,
          //     billAmount: r.bill_amount,
          //   }))
          // );
        } else {
          setShowInterestOnly(false);
          setBilledRows([]);
        }
      })
      .catch(() => {
        setShowInterestOnly(false);
      });
  }, [contractId, draftId]);

  const calculateInterestAmount = (principal, rate, days, convention) => {
    if (!rate) return 0;

    let base = 360;

    if (convention === "Actual/365") base = 365;
    if (convention === "30/360") days = 30;

    return ((principal * rate * days) / base / 100).toFixed(2);
  };

  useEffect(() => {
    const idToUse = draftId || contractId;
    if (!idToUse) return;

    axios
      .get(`${API}contracts/paymentDetail-view/${idToUse}/`, {
        headers: authHeader(),
      })
      .then((res) => {
        const map = {};
        let interestIndex = 1;

        res.data
          .filter((p) => p.paymenttype === "Interest Only")
          .forEach((p) => {
            // map by sequence instead of pmt_no
            map[interestIndex] = p.date_billed === null;
            interestIndex++;
          });

        console.log("FINAL MAP", map);

        setEditableInterestPeriods(map);
      });
  }, [contractId, draftId]);

  console.log("EDIT MAP", editableInterestPeriods);
  // console.log("ROW", row);

  useEffect(() => {
    if (interestRateType === "Fixed") {
      setNewInterestRate(contractdetails?.iir || 0);
    }
  }, [interestRateType, contractdetails]);

  return (
    <>
      <div className="container-fluid px-3 ">
        <ToastContainer />
        {/* Modification Type Selector */}
        {/* <div className="card mt-3 ">
              <div className="card-body col-md-4">
                <label className="col-xl-6 col-form-label">{t("Modification Type")}</label>
      
                <select
                  className="form-control col-xl-4"
                  value={modificationType}
                  onChange={(e) => setModificationType(e.target.value)}
                  disabled
                >
                  <option value="">Select</option>
                  <option value="ExtendTerm">{t("Extend Term")}</option>
                  <option value="PaymentChange">{t("Payment Change")}</option>
                  {contractdetails?.contract_type === "Loan" && (
                    <option value="InterestRateChange">Interest Rate Change</option>
                  )}
      
                </select>
              </div>
            </div> */}

        {/* BUTTON – same place as Payment Change */}
         {currentModificationType === "InterestRateChange" && draftId && (
        <div className="mt-3  card-body justify-content-end mb-3">
          {/* <div className="d-flex justify-content-end mb-3"> */}
          <button className="btn btn-secondary" onClick={abandonContract}>
            {/* Abandon Contract */}
            Delete
          </button>
          &nbsp;
          {/* 🔥 SAVE — only when ContractMod */}
          <button
            className=" btn btn-primary"
            onClick={activateLoanModification}
          >
            Activate
          </button>
        </div>
         )}

          {currentModificationType === "DueDayChange" && (
    <>
     <div className="mt-3  card-body justify-content-end mb-3">
      {draftId && (
        <button
          className="btn btn-secondary"
          onClick={abandonContract}
        >
          Delete
        </button>
      )}

      &nbsp;

      {draftId && (
        <button
          className="btn btn-primary"
          onClick={activateLoanModification}
        >
          Activate
        </button>
      )}
      </div>
    </>
  )}

        {/* INTEREST INPUT */}
        {/* {openPane && ( */}
        {currentModificationType === "InterestRateChange" && openPane  && (
          <div className="card mb-3">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <label className="col-form-label">
                    Current Interest Rate
                  </label>
                  <input
                    className="form-control"
                    value={contractdetails?.iir}
                    disabled
                  />
                </div>

                {/* Interest Rate Type */}
                <div className="col-md-4">
                  <label className="col-form-label">Interest Rate Type</label>

                  <div className="d-flex gap-3 mt-2">
                    <div className="form-check">
                      <input
                        type="radio"
                        name="interestRateType"
                        value="Fixed"
                        className="form-check-input"
                        checked={interestRateType === "Fixed"}
                        disabled // disable if draft exists
                        onChange={(e) => setInterestRateType(e.target.value)}
                      />
                      <label className="form-check-label">Fixed</label>
                    </div>

                    <div className="form-check">
                      <input
                        type="radio"
                        name="interestRateType"
                        value="Floating"
                        className="form-check-input"
                        checked={interestRateType === "Floating"}
                        disabled // disable if draft exists
                        onChange={(e) => setInterestRateType(e.target.value)}
                      />
                      <label className="form-check-label">Floating</label>
                    </div>
                  </div>
                </div>

                {/* Fixed Input */}
                {interestRateType === "Fixed" && (
                  <div className="col-md-4">
                    <label className="col-form-label">
                      New Interest Rate (%)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      placeholder="Interest rate"
                      className="form-control"
                      value={newInterestRate}
                      disabled // disable if draft exists
                      onChange={(e) => setNewInterestRate(e.target.value)}
                    />
                  </div>
                )}

                {/* Floating Inputs */}
                {interestRateType === "Floating" && (
                  <>
                    <div className="col-md-4">
                      <label className="col-form-label">Base Rate (%)</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        value={baseRate}
                        onChange={(e) => setBaseRate(e.target.value)}
                        onWheel={(e) => e.target.blur()} // ✅ disables scroll change
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault(); // ✅ disables up/down arrow change
                          }
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="col-form-label">Margin (%)</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        value={margin}
                        onChange={(e) => setMargin(e.target.value)}
                        onWheel={(e) => e.target.blur()} // ✅ disables scroll change
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault(); // ✅ disables up/down arrow change
                          }
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="col-form-label">
                        New Interest Rate (%)
                      </label>
                      <input
                        className="form-control"
                        value={newInterestRate}
                        disabled
                      />
                    </div>
                  </>
                )}

                {/* <div className="col-md-6">
                <label className="col-form-label">New Interest Rate (%)</label>
                <input
                  type="number"
                  step="0.01"
                  placeholder="Interest rate"
                  className="form-control"
                  value={newInterestRate}
                  onChange={(e) => setNewInterestRate(e.target.value)}
                />
              </div> */}
              </div>
              <div className="col-md-7">
                {showInterestOnly && (
                  <div className="card mt-3 p-3">
                    <h6>Interest Only – Bill</h6>

                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Period</th>
                          <th>Interest Rate</th>
                          <th>Day Convention</th>
                          <th>Bill Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {billedRows.map((row, index) => (
                          <tr key={index}>
                            <td>{row.period}</td>

                            <td>
                              <input
                                className="form-control"
                                value={row.interestRate}
                                // disabled   // 🔥 IMPORTANT (billed = readonly)
                                disabled={
                                  editableInterestPeriods[row.period] === false
                                }
                                onChange={(e) => {
                                  const value = parseFloat(e.target.value) || 0;

                                  const updated = [...billedRows];
                                  updated[index].interestRate = value;

                                  updated[index].billAmount =
                                    calculateInterestAmount(
                                      contractdetails.loanamount,
                                      value,
                                      row.periodDays,
                                      updated[index].dayConvention,
                                    );

                                  setBilledRows(updated);
                                }}
                              />
                            </td>

                            <td>
                              <select
                                className="form-control"
                                value={row.dayConvention}
                                disabled={
                                  editableInterestPeriods[row.period] === false
                                }
                                //  onChange={(e) =>
                                //                     setDayConvention(e.target.value)
                                //                 }
                                onChange={(e) => {
                                  const updated = [...billedRows];
                                  updated[index].dayConvention = e.target.value;

                                  updated[index].billAmount =
                                    calculateInterestAmount(
                                      contractdetails.loanamount,
                                      updated[index].interestRate,
                                      row.periodDays,
                                      e.target.value,
                                    );

                                  setBilledRows(updated);
                                }}
                              >
                                <option value="30/360">30/360</option>
                                <option value="Actual/365">Actual / 365</option>
                                <option value="Actual/360">Actual / 360</option>
                              </select>
                              {/* <input
                className="form-control"
                value={row.dayConvention}
                // disabled
                disabled={editableInterestPeriods[row.period] === false}              /> */}
                            </td>

                            <td className="text-end">{row.billAmount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <button
                className="btn btn-primary mt-3"
                onClick={submitInterestChange}
              >
                Save
              </button>
            </div>
          </div>
        )}

        {currentModificationType === "DueDayChange" && (
  <LoanDueDayChangePane
    contractdetails={contractdetails}
    draftContract={draftContract}
    contractId={contractId}
    draftId={draftId}
    recalcVersion={recalcVersion}
    onDraftCreated={(id) => {
      setDraftId(id);
      setRecalcVersion((v) => v + 1);
    }}
    onReadyToSave={(rows, amort) => {
      setMergedPaymentDetails(rows);
      setAmortData(amort);
    }}
  />
)}

{currentModificationType === "InterestRateChange" && (
        // {/* DISPLAY SCHEDULES */}
        // {/* {draftId && ( */}
        <LoanPaymentChangePane
          contractId={contractId}
          draftId={draftId}
          recalcVersion={recalcVersion}
          onReadyToSave={(rows, amort) => {
            setMergedPaymentDetails(rows);
            setAmortData(amort);
          }}
        />
)}
        {/* )} */}
      </div>
    </>
  );
}
